import { initializeApp } from 'firebase/app'
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore'
import {
  GoogleAuthProvider,
  browserLocalPersistence,
  getAuth,
  setPersistence,
} from 'firebase/auth'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

export const hasValidFirebaseEnv =
  !!firebaseConfig.apiKey &&
  firebaseConfig.apiKey !== 'your_api_key_here' &&
  !!firebaseConfig.authDomain &&
  firebaseConfig.authDomain !== 'your_project.firebaseapp.com' &&
  !!firebaseConfig.projectId &&
  firebaseConfig.projectId !== 'your_project_id' &&
  !!firebaseConfig.appId &&
  firebaseConfig.appId !== '1:123456789:web:abcdef123456'

const app = initializeApp(firebaseConfig)
export const db = getFirestore(app)
export const auth = getAuth(app)
export const storage = getStorage(app)
export const googleProvider = new GoogleAuthProvider()

googleProvider.setCustomParameters({ prompt: 'select_account' })

setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.warn('Failed to set auth persistence.', error)
})

// Enable offline persistence untuk menghemat reads (GRATIS reads dari cache!)
if (typeof window !== 'undefined') {
  enableIndexedDbPersistence(db).catch((err) => {
    if (err.code === 'failed-precondition') {
      console.warn(
        'Multiple tabs open, persistence can only be enabled in one tab at a time.',
      )
    } else if (err.code === 'unimplemented') {
      console.warn('Browser does not support persistence.')
    }
  })
}

export default app
